import React from 'react'

const Footer: React.FC = () => {
  const year = new Date().getFullYear()
  return (
    <footer className='footer-container'>
      <span>&copy; {year} - Angle</span>
    </footer>
  )
}

export default Footer
